var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardRgz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 11.6673L9.66602 11.6673L9.66602 13.2507L3.33268 13.2507L3.33268 11.6673ZM3.33268 8.50065L9.66602 8.50065L9.66602 10.084L3.33268 10.084L3.33268 8.50065ZM8.08268 0.583984L1.74935 0.583984C0.878516 0.583984 0.166016 1.29648 0.166016 2.16732L0.166016 14.834C0.166016 15.7048 0.870599 16.4173 1.74143 16.4173L11.2493 16.4173C12.1202 16.4173 12.8327 15.7048 12.8327 14.834L12.8327 5.33398L8.08268 0.583984ZM11.2493 14.834L1.74935 14.834L1.74935 2.16732L7.29102 2.16732L9.29102 4.12565L11.2493 6.12565L11.2493 14.834Z",
    fill: "#2C2D3E",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRgz);
export default __webpack_public_path__ + "static/media/dashboard-rgz.51048837641d1422bff1d6aadd59d8ee.svg";
export { ForwardRef as ReactComponent };